import { render, staticRenderFns } from "./DocumentRoot.vue?vue&type=template&id=c26bf174&scoped=true"
import script from "./DocumentRoot.vue?vue&type=script&lang=ts"
export * from "./DocumentRoot.vue?vue&type=script&lang=ts"
import style0 from "./DocumentRoot.vue?vue&type=style&index=0&id=c26bf174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26bf174",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
